import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useBranding } from "./BrandingContext.js";
export function LeaderboardShell({ title, subtitle, rotate, children }) {
    const branding = useBranding();
    useEffect(() => {
        document.title = `Leaderboard: ${title}`;
        return () => { document.title = "VMS Hub"; };
    }, [title]);
    const rotateStyle = rotate
        ? {
            transform: `rotate(${rotate}deg)`,
            transformOrigin: "center center",
            width: "100vh",
            height: "100vw",
            position: "fixed",
            top: "50%",
            left: "50%",
            marginTop: "-50vw",
            marginLeft: "-50vh",
        }
        : {};
    const pageStyle = {
        ...rotateStyle,
        ...(branding?.backgroundColor ? { backgroundColor: branding.backgroundColor } : {}),
        ...(branding?.backgroundImageUrl
            ? {
                backgroundImage: `url(${branding.backgroundImageUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }
            : {}),
    };
    const logoUrl = branding?.logoUrl || "/img/fpzero.svg";
    return (_jsxs("div", { className: "lb-page h-screen bg-gray-950 text-white flex flex-col overflow-hidden", style: pageStyle, children: [_jsxs("header", { className: "lb-header flex-shrink-0 px-8 pt-8 pb-4 text-center", children: [_jsx("img", { src: logoUrl, alt: "Logo", className: "lb-logo mx-auto mb-3 object-contain h-auto w-[70%] max-h-[20vh]" }), _jsx("h1", { className: "lb-title text-3xl font-bold tracking-tight bigscreen:text-5xl", style: branding?.pageTextColor ? { color: branding.pageTextColor } : undefined, children: title }), subtitle && (_jsx("p", { className: "lb-subtitle text-sm text-gray-400 mt-1 bigscreen:text-2xl", style: branding?.pageSubtitleColor ? { color: branding.pageSubtitleColor } : undefined, children: subtitle }))] }), _jsx("main", { className: "lb-content flex-1 min-h-0 overflow-hidden px-6", children: _jsx("div", { className: "max-w-2xl landscape:max-w-4xl bigscreen:max-w-5xl bigscreen:landscape:max-w-[1792px] mx-auto h-full", children: children }) }), _jsx("footer", { className: "lb-footer flex-shrink-0 px-8 py-3 text-center bg-white/60", children: _jsxs("div", { className: "flex items-center justify-center gap-2", children: [_jsx("span", { className: "text-xs text-black tracking-wide", children: "Powered by" }), _jsx("img", { src: "/img/fpzero.svg", alt: "FPZERO Simulators", className: "h-4 opacity-70" })] }) }), branding?.customCss && (_jsx("style", { dangerouslySetInnerHTML: { __html: branding.customCss } }))] }));
}
//# sourceMappingURL=LeaderboardShell.js.map